import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditableValue } from "./EditableValue";

const iconBtnSx = {
  color: "#5C6B7A",
  "&:not(:disabled):hover": { color: "#002A5C" },
  "&.Mui-disabled": { color: "#C4CDD8" },
};

interface Props {
  currentPage: number;
  numPages: number;
  onGoToPage: (page: number) => void;
}

export function PageNavigator({ currentPage, numPages, onGoToPage }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        bgcolor: "#EDF1F7",
        borderRadius: 2,
        px: 1,
      }}
    >
      <Tooltip title="Previous page">
        <span>
          <IconButton
            onClick={() => onGoToPage(currentPage - 1)}
            disabled={currentPage <= 1}
            size="small"
            sx={iconBtnSx}
          >
            <NavigateBeforeIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Typography variant="caption" sx={{ color: "#5C6B7A", fontWeight: 500 }}>
        Page
      </Typography>
      <EditableValue
        display={String(currentPage)}
        initialDraft={String(currentPage)}
        onCommit={(v) => {
          const n = parseInt(v);
          if (!isNaN(n)) onGoToPage(Math.max(1, Math.min(numPages, n)));
        }}
      />
      <Typography variant="caption" sx={{ color: "#8E99A8" }}>
        / {numPages}
      </Typography>
      <Tooltip title="Next page">
        <span>
          <IconButton
            onClick={() => onGoToPage(currentPage + 1)}
            disabled={currentPage >= numPages}
            size="small"
            sx={iconBtnSx}
          >
            <NavigateNextIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
